import type { ElementType } from 'react';

import InfoIcon from '@shieldpay/bumblebee/icons/InfoIcon';

import { Heading } from '@shieldpay/bumblebee/heading';
import { Column } from '@shieldpay/bumblebee/layout';
import { Table } from '@shieldpay/bumblebee/table';
import { Text } from '@shieldpay/bumblebee/text';

export const LinkAppearance = ({ Component }: { Component: ElementType }) => (
  <>
    <Column spacing="base">
      <Heading level="3" variant="title">
        Inherited text size links
      </Heading>
      <Text paragraph variant="section">
        This is a{' '}
        <Component href="#" variant="text-underline">
          “text-underline” variant
        </Component>
        , hope you have enjoyed the show.
      </Text>
      <Text paragraph>
        This is a{' '}
        <Component href="#" variant="text-link">
          “text-link” variant
        </Component>
        , hope you have enjoyed the show.
      </Text>
      <Text paragraph>
        This is a{' '}
        <Component href="#" disabled variant="text-link">
          disabled link(text-link)
        </Component>
        , soz.
      </Text>
    </Column>
    <Column spacing="base">
      <Heading level="3" variant="title">
        Fixed size links
      </Heading>
      <Table caption="links styles">
        <Table.Head>
          <Table.Row>
            <Table.HeaderCell>Small link</Table.HeaderCell>
            <Table.HeaderCell>Medium link</Table.HeaderCell>
          </Table.Row>
        </Table.Head>

        <Table.Body>
          <Table.Row>
            <Table.DataCell>
              <Component
                href="#"
                LeftIcon={InfoIcon}
                size="small"
                variant="text-underline"
              >
                Small link with icon on left
              </Component>
            </Table.DataCell>
            <Table.DataCell>
              <Component
                href="#"
                LeftIcon={InfoIcon}
                size="medium"
                variant="text-underline"
              >
                Medium link with icon on left
              </Component>
            </Table.DataCell>
          </Table.Row>
          <Table.Row>
            <Table.DataCell>
              <Component
                href="#"
                RightIcon={InfoIcon}
                size="small"
                variant="text-underline"
              >
                Small link with icon on right
              </Component>
            </Table.DataCell>
            <Table.DataCell>
              <Component
                href="#"
                RightIcon={InfoIcon}
                size="medium"
                variant="text-underline"
              >
                Medium link with icon on right
              </Component>
            </Table.DataCell>
          </Table.Row>
        </Table.Body>
      </Table>
    </Column>
  </>
);
